import ProductCard from "../ProductCard";
import { useNavigate } from "react-router-dom";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { useRef } from "react";




const Bestseller = ({ products }) => {
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  // Scroll left/right by container width
  const scroll = (direction) => {
    if (scrollRef.current) {
      const { clientWidth, scrollLeft } = scrollRef.current;
      const scrollAmount = clientWidth; // scroll by visible width
      scrollRef.current.scrollTo({
        left: direction === "left" ? scrollLeft - scrollAmount : scrollLeft + scrollAmount,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="w-full relative">
      <h2 className="text-3xl font-light text-center mb-10 tracking-wide">
        Bestseller
      </h2>

      {/* Left Arrow */}
      <button
        onClick={() => scroll("left")}
        className="absolute left-0 top-1/2 -translate-y-1/2 z-20 bg-white rounded-full p-2 shadow-md hover:bg-black hover:text-white transition flex"
      >
        <FiChevronLeft size={24} />
      </button>

      {/* Right Arrow */}
      <button
        onClick={() => scroll("right")}
        className="absolute right-0 top-1/2 -translate-y-1/2 z-20 bg-white rounded-full p-2 shadow-md hover:bg-black hover:text-white transition flex"
      >
        <FiChevronRight size={24} />
      </button>

      {/* Product Container */}
      <div
        ref={scrollRef}
        className="flex overflow-x-auto scrollbar-hide gap-4 px-4"
      >
        {products.map((product) => (
          <div
            key={product._id || product.id}
            className="flex-shrink-0 w-full sm:w-1/2 lg:w-1/4 cursor-pointer"
            onClick={() => navigate(`/product/${product._id || product.id}`)}
          >
            <ProductCard product={product} />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Bestseller;